import React, { useState, useEffect, useRef } from "react";
// import { UserContext } from "../../hooks/UserContext";
import { Tabs, Tab, Container } from "react-bootstrap";

//  Styles
import "./Admin.scss";

//  Hooks
import useAdminData from "../../hooks/useAdminData";

//  Components
import ProjectsTab from "./Tabs/ProjectsTab";
import TestimonialsTab from "./Tabs/TestimonialsTab";
import MessagesTab from "./Tabs/MessagesTab";
import Spinner from "../../components/Spinner";

const Admin = () => {
    // const { user } = useContext(UserContext);
    const [key, setKey] = useState("projects");
    const { data, getProjects, getTestimonials, getMessages, isLoading } = useAdminData();

    const timelineLoaded = useRef(false);

    useEffect(() => {
        async function fetchData() {
            await getProjects();
            await getTestimonials();
            await getMessages();
        }

        if (!timelineLoaded.current) {
            fetchData();
            timelineLoaded.current = true;
        }
    }, [getMessages, getProjects, getTestimonials]);

    return (
        <Container>
            <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={k => setKey(k)}
                className="mb-3"
                fill
            >
                <Tab eventKey="projects" title="Projects">
                    {isLoading ? (<Spinner color={'red'}/>) : (<ProjectsTab projects={data.projects} />)}
                    
                </Tab>
                <Tab eventKey="testimonials" title="Testimonials">
                    {isLoading ? (<Spinner color={'red'}/>) : (<TestimonialsTab testimonials={data.testimonials} />)}
                    
                </Tab>
                <Tab eventKey="messages" title="Messages">
                    {isLoading ? (<Spinner color={'red'}/>) : (<MessagesTab messages={data.messages} />)}
                    
                </Tab>
            </Tabs>
        </Container>
    );
};

export default Admin;
